export default {
  others: 'otros'
}
